import {Section, SectionHeader, SubSectionHeader} from '../../../components/Form/FormStyles';
import {NumberOfIndirectPeopleImpactedControl} from '../Community/NumberOfIndirectPeopleImpactedControl';
import {EditedProject, visibleFundingParticipations} from '../EditedProject';
import {CommunityEventDatesControl} from '../MultipleProjectTypes/CommunityEventDatesControl';
import {FundingPartnersControl} from '../MultipleProjectTypes/FundingPartnersControl';
import {ImagesSection} from '../MultipleProjectTypes/ImagesSection';
import {ImpactStoryCompletedControl} from '../MultipleProjectTypes/ImpactStoryCompletedControl';
import {ImpactStoryCompletedShortControl} from '../MultipleProjectTypes/ImpactStoryCompletedShortControl';
import {ImpactStoryInProgressControl} from '../MultipleProjectTypes/ImpactStoryInProgressControl';
import {ImpactStoryInProgressShortControl} from '../MultipleProjectTypes/ImpactStoryInProgressShortControl';
import {NameControl} from '../MultipleProjectTypes/NameControl';
import {ProjectIdControl} from '../MultipleProjectTypes/ProjectIdControl';
import {ProjectTypeControl} from '../MultipleProjectTypes/ProjectTypeControl';
import {DemoProjectStatusControl} from '../MultipleProjectTypes/DemoProjectStatusControl';
import {ShowInLIDControl} from '../MultipleProjectTypes/ShowInLIDControl';
import {ReasonForPlantingControl} from '../MultipleProjectTypes/ReasonForPlantingControl';
import {TreeSpeciesReadOnly} from '../MultipleProjectTypes/TreeSpeciesReadOnly';
import {BenefitsSection} from '../MultipleProjectTypes/BenefitsSection';

export function CommunityTreeDistributorProject({
    project,
    setProjectAndValidate,
    newProject,
    generateShortImpactStory
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
    completedProjectSetProjectAndValidate: (project: EditedProject) => void;
    newProject?: boolean;
    navigationPromptActive: boolean;
    setNavigationPromptActive: (navigationPromptActive: boolean) => void;
    registerSave: (f: (projectId: number) => void) => void;
    registerHasChanges: (f: () => boolean) => void;
    hasChangesUpdated: () => void;
    generateShortImpactStory: (originalText: string) => Promise<string>;
    reloadProject?: () => void;
}) {
    return (
        <>
            <Section>
                <SectionHeader>What is the project?</SectionHeader>
                <ProjectIdControl project={project} />
                <DemoProjectStatusControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                />
                <ShowInLIDControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                />
                <ProjectTypeControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                    hideValidateControl={true}
                />
                <NameControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                    hideValidateControl={true}
                />
            </Section>

            <Section>
                <SectionHeader>When is the project?</SectionHeader>
                <CommunityEventDatesControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                />
            </Section>

            <Section>
                <SectionHeader>Why is the project being done?</SectionHeader>
                <ReasonForPlantingControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                    hideValidateControl={true}
                />
                <ImpactStoryInProgressControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                    disabled={project.ControlledByAutomation}
                />
                <ImpactStoryInProgressShortControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                    generateShortImpactStory={generateShortImpactStory}
                />
                <ImpactStoryCompletedControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                    disabled={project.ControlledByAutomation}
                />
                <ImpactStoryCompletedShortControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                    generateShortImpactStory={generateShortImpactStory}
                />
            </Section>

            <Section>
                <SectionHeader>Who is participating in the project?</SectionHeader>
                <FundingPartnersControl
                    participations={visibleFundingParticipations(project)}
                    projectId={project.Id}
                    projectType={project.ProjectType.current}
                    readOnly
                />
                <SubSectionHeader>People Impacted</SubSectionHeader>
                <NumberOfIndirectPeopleImpactedControl
                    project={project}
                    setProjectAndValidate={setProjectAndValidate}
                />
            </Section>

            <Section>
                <SectionHeader>What is being planted?</SectionHeader>
                <TreeSpeciesReadOnly project={project} />
            </Section>

            <BenefitsSection project={project} />

            <ImagesSection
                newProject={newProject}
                project={project}
                setProjectAndValidate={setProjectAndValidate}
            />
        </>
    );
}
